import React, { useState, useLayoutEffect, useEffect } from 'react'
import { Menu } from 'react-feather'
import { connect, mapStateToProps, mapDispatchToProps } from '../../helpers/Common'

const SIDEBAR_COLLAPSED_KEY = 'sidebar-collapsed'

const Leftbar = (props) => {
  // const [levelMenu, setLevelMenu] = useState(false)
  const width = useWindowSize()
  // desktop: sembunyikan sidebar sepenuhnya (mirip mobile), status disimpan per browser
  const [desktopCollapsed, setDesktopCollapsed] = useState(() => {
    try {
      return window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'
    } catch (e) {
      return false
    }
  })

  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', desktopCollapsed)
    try {
      window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, desktopCollapsed ? '1' : '0')
    } catch (e) {}
  }, [desktopCollapsed])

  // tour guide menyorot menu sidebar, jadi sidebar harus terlihat
  useEffect(() => {
    if (props.redux.isTourOpen) setDesktopCollapsed(false)
  }, [props.redux.isTourOpen])

  // desktop + sidebar disembunyikan: arahkan kursor ke tepi kiri untuk membuka sementara
  const [peek, setPeek] = useState(false)

  useEffect(() => {
    document.body.classList.toggle('sidebar-peek', peek)
  }, [peek])

  useEffect(() => {
    if (!desktopCollapsed) setPeek(false)
  }, [desktopCollapsed])

  useEffect(() => {
    if (!peek) return
    const sidebar = document.querySelector('.sidebar-wrapper')
    // tutup saat kursor menjauh dari sidebar
    const onMouseMove = (e) => {
      const right = sidebar ? sidebar.getBoundingClientRect().width : 280
      if (e.clientX > right + 20) setPeek(false)
    }
    // tutup saat klik menu yang berpindah halaman (bukan menu yang membuka submenu)
    const onClick = (e) => {
      const anchor = e.target.closest('a')
      const href = anchor && anchor.getAttribute('href')
      if (href && href !== '#javascript') setPeek(false)
    }
    document.addEventListener('mousemove', onMouseMove)
    if (sidebar) sidebar.addEventListener('click', onClick)
    return () => {
      document.removeEventListener('mousemove', onMouseMove)
      if (sidebar) sidebar.removeEventListener('click', onClick)
    }
  }, [peek])

  function useWindowSize () {
    const [size, setSize] = useState([0, 0])
    useLayoutEffect(() => {
      function updateSize () {
        setSize(window.innerWidth)
      }
      window.addEventListener('resize', updateSize)
      updateSize()
      return () => window.removeEventListener('resize', updateSize)
    }, [])
    return size
  }

  useEffect(() => {
    const ignoreClick_On_Out_side_Element = document.getElementById('out_side_click')
    const ignoreClick_On_Main_Nav_Element = document.getElementById('sidebar-menu')
    document.addEventListener('click', function (event) {
      const isClickOutSideElement = ignoreClick_On_Out_side_Element.contains(event.target)
      const isClickMainNavElement = ignoreClick_On_Main_Nav_Element.contains(event.target)
      if (window.innerWidth <= 991 && !isClickOutSideElement && !isClickMainNavElement) {
        // Do something click is outside specified element
        document.querySelector('.page-header').className = 'page-header close_icon'
        document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper close_icon '
      }
    })
  }, [width])

  const responsive_openCloseSidebar = () => {
    if (width <= 991) {
      document.querySelector('.page-header').className = 'page-header'
      document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper '
    } else {
      setDesktopCollapsed(collapsed => !collapsed)
    }
  }

  return (
    <>
      {desktopCollapsed && width > 991 && !peek && (
        <div className='sidebar-peek-trigger' onMouseEnter={() => setPeek(true)} />
      )}
      <div className='header-logo-wrapper' id='out_side_click'>
        <div className='toggle-sidebar' onClick={responsive_openCloseSidebar} style={{ display: 'block', cursor: 'pointer' }}>
          <Menu className='status_toggle middle sidebar-toggle' id='sidebar-toggle' />
        </div>
      </div>
      {/* <Col className='left-header horizontal-wrapper pl-0 d-none d-md-block' /> */}
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Leftbar)
